import { Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AzTabsComponent, AzTab } from '../../../../shared/components/az-tabs/az-tabs.component';
import { LegalEntityInformationComponent } from '../legal-entity-information/legal-entity-information.component';
import { LegalEntityDocumentsComponent } from '../legal-entity-documents/legal-entity-documents.component';
import { ScrollActivityDirective } from '../../../../shared/directives/scroll-activity.directive';

@Component({
  selector: 'app-legal-entity-detail',
  standalone: true,
  imports: [
    CommonModule,
    AzTabsComponent,
    LegalEntityInformationComponent,
    LegalEntityDocumentsComponent,
    ScrollActivityDirective,
  ],
  templateUrl: './legal-entity-detail.component.html',
  styleUrl: './legal-entity-detail.component.scss',
})
export class LegalEntityDetailComponent {
  @Input() entityId: number | null = null;

  tabs: AzTab[] = [
    { id: 'info', label: 'Legal Entity Information' },
    { id: 'documents', label: 'Documents' },
  ];

  activeTabId = signal<string>('info');

  onTabChange(tabId: string): void {
    this.activeTabId.set(tabId);
  }
}
